import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// CSS
import styles from '@UILayer/UILayer.scss';

// MANAGERS
import { EButtonEvents } from '@Managers/Events/ButtonEvents';
import EventsCenter from '@Managers/Events/EventsCenter';

// REDUX
import { getGlobalStyles, getTurboModeState } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

import { gameInstance } from '@Game/GameComponent';
import { getCurrentTurboLevel } from '@Managers/TurboManager/TurboManager';
import { KeyboardEventCheck } from '@Tools/KeyboardEventCheck';

const AutoTurboButton: React.FC<{ uiFreeze: boolean }> = ({ uiFreeze }) => {
    const [state, setState] = useReducer((state: {}, newState: any) => ({ ...state, ...newState }), {});

    const gameStoreTurboModeState = useAppSelector(getTurboModeState);
    const globalStyles = useAppSelector(getGlobalStyles);
    const { t } = useTranslation();
    const turboLevel = gameInstance?.gameStore
        ? getCurrentTurboLevel(gameInstance.gameStore)
        : (gameStoreTurboModeState?.specialGameLevel ?? gameStoreTurboModeState?.baseGameLevel);
    const buttonCN = cn(
        styles.turboMode_btn,
        styles.gameplay_btn,
        styles.gameplay_btn_type2,
        globalStyles.orientation,
        globalStyles.wcaMode,
        gameStoreTurboModeState?.active ? styles.active : false,
        turboLevel === 0 ? styles.turbo_level1 : false,
        turboLevel === 1 ? styles.turbo_level2 : false,
        turboLevel === 2 ? styles.turbo_level3 : false,
        uiFreeze ? styles.disabled : null
    );

    useEffect(() => {}, []);

    function buttonAction(e: React.MouseEvent<any>) {
        if (!uiFreeze) {
            if (e) e.stopPropagation();
            EventsCenter.emit(EButtonEvents.TURBO_BUTTON_PRESSED);
        }
    }

    return (
        <button
            tabIndex={0}
            className={buttonCN}
            id="ui_button_turbo"
            aria-description={t('WCA_TOGGLE_TURBO_MODE_BUTTON')}
            onPointerDown={(e) => buttonAction(e)}
            onKeyDown={(e) => KeyboardEventCheck(e, buttonAction)}
        ></button>
    );
};

export default AutoTurboButton;
